import Image from "next/image";
import { Band, Eyebrow, SoftFallback, displayFont } from "./band-helpers";
import { runwayProducts } from "@/lib/content-blocks-data";

export function BestsellerRunway() {
  return (
    <Band className="bg-[#fafcf8] py-12 sm:py-16">
      <Eyebrow>Bestseller runway</Eyebrow>
      <h2
        className={`${displayFont.className} mt-3 text-[clamp(1.7rem,3.2vw,2.7rem)] font-bold leading-[1.1] tracking-tight storefront-text-heading`}
      >
        A wider product run that keeps the sales energy moving.
      </h2>
      <p className="mt-4 max-w-2xl text-base leading-7 storefront-text-body sm:text-lg">
        This stays flatter and more campaign-led than a standard product grid,
        which makes it a better fit for a landing page that still needs real
        menu proof.
      </p>

      <div className="relative mt-8">
        <div className="pointer-events-none absolute left-0 top-0 z-10 hidden h-full w-8 bg-gradient-to-r from-[#fafcf8] to-transparent sm:block" />
        <div className="pointer-events-none absolute right-0 top-0 z-10 hidden h-full w-8 bg-gradient-to-l from-[#fafcf8] to-transparent sm:block" />

        <div
          className="flex gap-4 overflow-x-auto pb-4"
          role="list"
          style={{
            scrollSnapType: "x mandatory",
            scrollPaddingLeft: "1.25rem",
            WebkitOverflowScrolling: "touch",
          }}
        >
          {runwayProducts.map((product) => (
            <article
              key={product.name}
              role="listitem"
              className="w-[78vw] flex-shrink-0 overflow-hidden rounded-[1.6rem] border storefront-border-soft bg-white shadow-[0_20px_48px_-28px_rgba(0,39,0,0.22)] sm:w-[44vw] lg:w-[22rem]"
              style={{ scrollSnapAlign: "start" }}
            >
              <div className="relative aspect-[5/4] overflow-hidden border-b border-[rgba(0,39,0,0.06)] bg-white">
                {product.image ? (
                  <Image
                    src={product.image}
                    alt={product.name}
                    fill
                    sizes="(min-width: 1024px) 22rem, (min-width: 640px) 44vw, 78vw"
                    className="object-cover"
                    style={{ objectPosition: product.objectPosition ?? "center" }}
                  />
                ) : (
                  <SoftFallback />
                )}
              </div>
              <div className="space-y-3 px-5 py-5">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#0b7b31]">
                  {product.price}
                </p>
                <h3 className="text-2xl font-semibold tracking-tight storefront-text-heading">
                  {product.name}
                </h3>
                <p className="text-sm leading-6 storefront-text-body">
                  {product.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </Band>
  );
}
